import React from 'react';
import PropTypes from 'prop-types';
import * as types from '../../../constants/actionTypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as locationTagActions } from '../../../actions/locationTagActions';
import { DEFAULT_PAGE_SIZE } from '../../../constants/constants';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import Drawer from '../../Common/Drawer/Drawer';
import Icon from '../../Common/Icon';
import Notification from '../../../components/Common/Notification';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import Tag from '../../Common/Tag/Tag';
import LocationTagForm from './locationTagForm';
import { getDataTableSortFields, getSearchParamSortFields } from '../../../helpers/sortHelper';
import { getNullableOnChangeValue } from '../../../helpers/multiselect';

export class LocationTags extends React.Component {

    constructor(props, context) {
        super(props, context);

        const newLocationTag = {
            id: 0,
            name: "",
            isActive: true,
            subscriptionId: props.subscriptionId,
            backgroundColor: "#8F8F8F"
        };

        this.state = {
            locationTags: [],
            totalCount: 0,
            isFetching: false,
            isSaving: false,
            selectedLocationTag: newLocationTag,
            editLocationTag: newLocationTag,
            selectedLocationTagId: 0,
            newLocationTag: newLocationTag,
            drawerOpen: false,
            isFormValid: true,
            searchParams: {
                subscriptionId: props.subscriptionId,
                isActive: true,
                pageSize: DEFAULT_PAGE_SIZE,
                pageNumber: 1,
                sortBy: "name",
                sortDir: "asc",
                name: ""
            }
        };

    }

    async componentDidMount() {
        await this.search();
    }

    async search() {
        try {
            this.setState({ isFetching: true });
            const result = await this.props.locationTagActions.search(this.state.searchParams);
            const payload = result.payload;
            if (result.type === types.SEARCH_LOCATION_TAGS_SUCCESS) {
                this.setState({ locationTags: payload.results, totalCount: payload.totalCount });
            } else if (result.type === types.SEARCH_LOCATION_TAGS_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isFetching: false });
        }
    }

    saveClick = async () => {
        try {
            this.setState({ isSaving: true });
            const result = await this.props.locationTagActions.saveLocationTag(this.state.editLocationTag)

            if (result.type === types.CREATE_LOCATION_TAG_SUCCESS || result.type === types.UPDATE_LOCATION_TAG_SUCCESS) {
                Notification("success", "Save Successful", "Tag saved successfully")
                this.setState({ drawerOpen: false });
                this.setState({ searchParams: { ...this.state.searchParams, pageNumber: 1 } }, () => {
                    this.search();
                });
            } else if (result.type === types.CREATE_LOCATION_TAG_FAILURE || result.type === types.UPDATE_LOCATION_TAG_FAILURE) {
                this.setState({ errorMessage: result.payload.message });
                Notification("error", "An Error Occurred", result.payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isSaving: false });
        }
    }

    onFormChange = (name, value) => {
        this.setState({ editLocationTag: { ...this.state.editLocationTag, [name]: value } });
    }

    onAddNew = () => {
        this.setState({ selectedLocationTag: null, editLocationTag: this.state.newLocationTag, drawerOpen: true, errorMessage: "", isFormValid: true });
    }

    cancelClick = () => {
        this.setState({ drawerOpen: false });
    }

    activeTemplate = (rowData) => {
        if (rowData.isActive) {
            return <div className="text-success text-center"><Icon name="check-circle" /></div>;
        } else {
            return <div className="text-danger text-center"><Icon name="times-circle" /></div>;
        }
    }

    nameTemplate = (rowData) => {
        return <Tag backgroundColor={rowData.backgroundColor} title={rowData.name} />;
    }

    filterNameChange = (e) => {
        this.setState({ searchParams: { ...this.state.searchParams, name: e.target.value } });
    }

    keyUpName = (e) => {
        if (e.keyCode == 13) {
            this.search();
        }
    }

    onSort = ({ sortField, sortOrder }) => {
        const { sortBy, sortDir } = getSearchParamSortFields(sortField, sortOrder);
        if (sortBy !== this.state.searchParams.sortBy || sortDir !== this.state.searchParams.sortDir) {
            this.setState({
                searchParams: {
                    ...this.state.searchParams,
                    sortBy: sortBy,
                    sortDir: sortDir
                }
            }, this.search);
        }
    }

    selectLocationTag = (e) => {
        const newValue = e.value || this.state.selectedLocationTag;
        this.setState({ selectedLocationTag: newValue, editLocationTag: newValue, drawerOpen: true, isFormValid: true });
    }

    onActiveChange = (e) => {
        const selectedValue = getNullableOnChangeValue(e);

        this.setState({ searchParams: { ...this.state.searchParams, isActive: selectedValue } }, () => {
            this.search();
        });
    }

    onPageChange = (e) => {
        this.setState({ searchParams: { ...this.state.searchParams, pageNumber: (e.page + 1) } }, () => {
            this.search();
        });
    }

    render() {

        const activeOptions = [
            { label: "Yes", value: true },
            { label: "No", value: false },
            { label: "All", value: null }
        ];
        
        const activeFilter = (
                            <Dropdown
                                className="ui-column-filter"
                                value={this.state.searchParams.isActive}
                                options={activeOptions}
                                optionLabel="label"
                                optionValue="value"
                                onChange={this.onActiveChange}
                                placeholder="Select an option"
                            />
                        );

        const nameFilterElement =
            <input type="text" className="p-inputtext" placeholder="Filter by Name" size="50" onBlur={this.onSearchBlur} onChange={this.filterNameChange} onKeyUp={this.keyUpName} value={this.state.searchParams.name} />
        ;

        const { sortField, sortOrder } = getDataTableSortFields(this.state.searchParams);

        return (
            <div>
                {this.state.drawerOpen ?
                    <Drawer isWide={false} title="Location Tag" onSaveClick={this.saveClick} onCancelClick={this.cancelClick}>
                        <LocationTagForm
                            onFormChange={this.onFormChange}
                            isFormValid={this.state.isFormValid}
                            onSubmit={this.saveClick}
                            locationTag={this.state.editLocationTag}
                        />
                    </Drawer>                
                :
                ""
                }

                <LoadingIndicator isLoading={this.state.isFetching || this.state.isSaving} hideWhileLoading={true}>
                    <div>
                        <div className="identifier-header">
                            <div className="title">Tags</div>
                            <div className="close">
                                <button type="button" onClick={this.props.onClose} alt="close popup"><Icon name="times" /></button>
                            </div>
                        </div>

                        <div className="identifier-add-new">
                            <div className="col-sm-12">
                                <button type="button" className="btn btn-primary" onClick={this.onAddNew} alt="close popup"><span className="me-2">Add New</span><Icon name="plus-circle" /></button>
                            </div>
                        </div>

                        <div className="identifier-results-table">
                            <DataTable
                                filterDisplay="row"
                                className="p-datatable-sm p-datatable-striped"
                                value={this.state.locationTags}
                                selectionMode="single"
                                selection={this.state.selectedLocationTag}
                                onSelectionChange={this.selectLocationTag}
                                sortField={sortField}
                                sortOrder={sortOrder}
                                onSort={this.onSort}
                                >
                                <Column field="name" header="Name" sortable={true} body={this.nameTemplate} filter={true} filterElement={nameFilterElement} />
                                <Column field="isActive" header="Active" sortable={true} body={this.activeTemplate} style={{ width: '120px' }} filter={true} filterElement={activeFilter} />
                            </DataTable>
                            {
                                this.state.totalCount > this.state.searchParams.pageSize &&
                                <Paginator
                                    rows={this.state.searchParams.pageSize}
                                    totalRecords={this.state.totalCount}
                                    first={(this.state.searchParams.pageNumber - 1) * this.state.searchParams.pageSize}
                                    onPageChange={this.onPageChange} />
                            }
                            <div className="results-count">Total records: {this.state.totalCount}</div>
                        </div>
                    </div>
                </LoadingIndicator>
            </div>
        );
    }

}

LocationTags.propTypes = {
    subscriptionId: PropTypes.number.isRequired,
    locationTagActions: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
}

function mapDispatchToProps(dispatch) {
    return {
        locationTagActions: bindActionCreators(locationTagActions, dispatch)
    };
}

export default connect(null, mapDispatchToProps)(LocationTags);

